import { createApi, CallApi, withAuth } from '@qwealth/qdata';

export const apiUrl = process.env.REACT_APP_QWEALTH_API;
export const bffApiUrl = `${process.env.REACT_APP_QWEALTH_QC_API}/qcash/`;
export const qcentralUrl = process.env.REACT_APP_QWEALTH_QC;

export const bffHouseholdApi = (householdId: string | number): CallApi =>
  withAuth(createApi(`${bffApiUrl}household/${householdId}`));
